import { type ClipType } from '@air/api/types';

import {
  getWorkspaceAgentGuidedVariantImageSelection,
  getWorkspaceAgentGuidedVariantSkipKind,
  type WorkspaceAgentGuidedVariantImageSelection,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentGuidedVariantSkipCounts';
export type WorkspaceAgentGuidedVariantImageSubject = {
  ext?: string | null;
  height: number | null;
  thumbnailUrl: string | null;
  type: ClipType;
  width: number | null;
};

export type WorkspaceAgentGuidedVariantImagePreviewSelection = WorkspaceAgentGuidedVariantImageSelection & {
  previewHeight: number | null;
  previewImageUrl: string | null;
  previewWidth: number | null;
};

/** Image counts for guided variants that show a settings preview; videos and other files are skipped. */
export const getWorkspaceAgentGuidedVariantImagePreviewSelection = (
  subjects: readonly WorkspaceAgentGuidedVariantImageSubject[],
): WorkspaceAgentGuidedVariantImagePreviewSelection => {
  const { imageCount, skippedFileCount, skippedVideoCount } = getWorkspaceAgentGuidedVariantImageSelection(subjects);

  let previewHeight: number | null = null;
  let previewImageUrl: string | null = null;
  let previewWidth: number | null = null;

  for (const subject of subjects) {
    if (getWorkspaceAgentGuidedVariantSkipKind(subject) !== 'image') {
      continue;
    }

    if (!previewImageUrl && subject.thumbnailUrl) {
      previewHeight = subject.height;
      previewImageUrl = subject.thumbnailUrl;
      previewWidth = subject.width;
    }
  }

  return {
    imageCount,
    previewHeight,
    previewImageUrl,
    previewWidth,
    skippedFileCount,
    skippedVideoCount,
  };
};
